import client, { apiEnv } from '../client';

export const requestAccessToken = (code) => {
  const codeVerifier = localStorage.getItem('code_verifier');
  const objToSend = {
    grant_type: apiEnv[apiEnv.env].grant_type_request_access_token,
    client_id: apiEnv[apiEnv.env].client_id_login,
    code_verifier: codeVerifier,
    code,
    scope: apiEnv[apiEnv.env].scope,
    redirect_uri: apiEnv[apiEnv.env].redirect_uri(
      window.location.pathname === '/car-detail'
        ? window.location.pathname
        : '/homepage',
    ),
  };
  return client.post(null, true)(
    apiEnv[apiEnv.env].urlAccessToken(),
    `${Object.keys(objToSend)
      .map((key) => `${key}=${objToSend[key]}`)
      .join('&')}`,
  );
};

export const convertAccessToken = (assertion) => {
  const objToSend = {
    grant_type: apiEnv[apiEnv.env].grant_type_convert_access_token,
    client_id: apiEnv[apiEnv.env].client_id_mcs,
    assertion,
  };
  return client.post(null, true)(
    apiEnv[apiEnv.env].urlConvertToken(),
    `${Object.keys(objToSend)
      .map((key) => `${key}=${objToSend[key]}`)
      .join('&')}`,
  );
};

export const refreshAccessToken = (refreshToken) => {
  const objToSend = {
    grant_type: apiEnv[apiEnv.env].grant_type_refresh_access_token,
    client_id: apiEnv[apiEnv.env].client_id_name,
    refresh_token: refreshToken,
    scope: apiEnv[apiEnv.env].scope,
  };
  return client.post(null, true)(
    apiEnv[apiEnv.env].urlAccessToken(),
    `${Object.keys(objToSend)
      .map((key) => `${key}=${objToSend[key]}`)
      .join('&')}`,
  );
};

export const parseJwtToken = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};



export const loginOnFerrari = (hasPrompt = true) => client.get()(apiEnv[apiEnv.env].loginUrl(), {
  scope: apiEnv[apiEnv.env].scope,
  response_type: apiEnv[apiEnv.env].response_type,
  redirect_uri: apiEnv[apiEnv.env].redirect_uri('/homepage'),
  client_id: apiEnv[apiEnv.env].client_id_name,
  ...(hasPrompt
    ? {}
    : {
      prompt: apiEnv[apiEnv.env].prompt,
    }),
});
